<template>
	<router-link v-if="!isLoading" :to="{ name: 'page', params: { id: 1 } }">
		<img
			class="btn-start"
			:src="titleImage"
			:alt="`${page.title} - ${page.text}`"
			v-on:load="sendMessage"
		/>
	</router-link>
	<!-- <v-card v-else class="text-xs-center">
		<v-container>
			<v-progress-circular
				:size="70"
				:width="7"
				color="primary"
				indeterminate
			></v-progress-circular>
		</v-container>
	</v-card> -->
</template>

<style>
.application--wrap {
	min-height: 0;
}

img.btn-start {
	display: block;
	width: 100%;
}
</style>

<script>
import { mapState } from 'vuex';

const params = new URLSearchParams(window.location.search);

export default {
	computed: {
		...mapState({
			page: 'page',
			isLoading: 'isLoading',
		}),
	},
	methods: {
		sendMessage() {
			window.parent.postMessage(
				{
					event: 'resize',
					height: Math.max(
						document.body.offsetHeight,
						document.documentElement.offsetHeight
					),
				},
				'*'
			);
		},
	},
	updated() {
		this.sendMessage();
	},
	created() {
		this.$store.dispatch('getPage', 999);
		this.$store.dispatch('resetResult');
	},
	data: function () {
		// if title_img from embedded render, otherwise redirect to page:1
		if (params.get('title_img')) {
			// console.log('if runs...');
			return {
				titleImage: params.get('title_img'),
			};
		} else {
			// console.log('else runs...');
			this.$router.push('/page/1');
			return {
				titleImage: params.get('title_img'),
			};
		}
		// return {
		// 	titleImage: params.get('title_img') || 'start.jpg',
		// };
	},
};
</script>
